// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_8e950454","subHeader":"_6e76ddfc"};